module.exports = __webpack_public_path__ + "static/media/pg.fcbe86ec.svg";